<template>
    <section>
        <h3>Amenities</h3>
        <ul class="grid three-cols">
            <li v-for="amenity in visibleAmenities" :key="amenity.key">
                <label class="type--checkbox">
                    <input type="checkbox" v-model="casiola.state.advancedFilters.amenityKeys" name="amenities" :value="amenity.key" />
                        <span><img v-if="amenity.highlighted" :src="`/wp-content/plugins/casiola/img/amenities/${amenity.key}.svg`" alt="">{{amenity.name}}</span>
                </label>
            </li>
        </ul>
        <div class="toggle-highlighted">
            <label>
                <input type="checkbox" v-model="highlightedOnly">
                <span>{{ highlightedOnly ? 'More amenities' : 'Less amenities' }}</span>
            </label>
        </div>
    </section>
</template>
<script>
import gql from 'graphql-tag'
import { watch, ref, computed } from 'vue'
import { useCasiolaStore } from '@/store'
import { useQuery } from '@vue/apollo-composable'

const query = gql`query Amenities($destinationId: Int, $destinationKey: String) {
  amenities(destinationId: $destinationId, destinationKey: $destinationKey) {
    id
    name
    key
    type
    highlighted
  }
}`

export default {
    setup() {
        // CASIOLA STORE
        const casiola = useCasiolaStore()

        const amenities = ref([])
        const filter = computed(() => {
            return {
                destinationId: casiola.state.baseFilters.destinations.length ? casiola.state.baseFilters.destinations[0] : null,
                destinationKey: casiola.state.baseFilters.destinationKey ? casiola.state.baseFilters.destinationKey : null,
            }
        })
        const onQueryResult = (data) => {
            amenities.value = data.amenities
        }
        const { result, onResult } = useQuery(query, filter);
        const handleResult = (data) => {
            onQueryResult(data)
        };
        watch(result, () => {
            if (!result.value) {
                return;
            }
            handleResult(result.value);
        }, {
            immediate: true
        });
        onResult(({ data }) => {
            if (data) {
                onQueryResult(data)
            }
        });
        const highlightedOnly = ref(true)
        const visibleAmenities = computed(() => {
            const sorted = [...amenities.value].sort((a, b) => (a === b) ? 0 : a ? 1 : -1)
            if (highlightedOnly.value) {
                return sorted.reduce((acc, a) => {
                    if (a.highlighted && acc.length < 6) {
                        acc.push(a)
                    }
                    return acc
                }, [])
            } else {
                return sorted
            }

        })

        return {
            casiola,
            highlightedOnly,
            visibleAmenities
        }
    }
}
</script>
<style src="@vueform/toggle/themes/default.css">
</style>